import { SandboxedTagMutation } from "@pjs/security";
import { Cke5BrMutation } from "./inline/Cke5BrMutation";

export const cke5BrTransform: SandboxedTagMutation = new Cke5BrMutation();
